import React, { useEffect } from 'react';
import {
    logout,
    webAuth,
    setUserData,
    resetAuth,
    authenticateUser
} from '../../store/ducks/AuthDuck';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/loading/Loading';

const Authorize = () => {
    const { isAuthenticated } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigation = useNavigate();

    const parseAuthToken = () => {
        if (window.location.hash) {
            webAuth.parseHash({ hash: window.location.hash }, (err, res) => {
                if (err) {
                    console.log('error', err);
                    resetAuth();
                    logout();
                    return;
                }

                const { email, name, picture, sub: id } = res.idTokenPayload;
                dispatch(setUserData({ email, name, picture, id }));
                dispatch(
                    authenticateUser(
                        res.idToken,
                        res.accessToken,
                        res.idTokenPayload
                    )
                );
            });
        }
    };

    useEffect(() => {
        parseAuthToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            console.log('use effecy activado!!!');
            navigation('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

    // eslint-disable-next-line react-hooks/exhaustive-deps

    return <Loading />;
};

export default Authorize;
